<template>
  <div v-if="visibile"
       class="loading-content is-fullscreen">
    <div class="el-loading-spinner loading-animate">
      <svg viewBox="0 0 60 60" width="56" height="56" class="circular">
        <circle cx="30" cy="30" r="28" stroke="#EFF2F8" stroke-width="4" fill="none"></circle>
        <circle cx="30" cy="30" r="28" fill="none" stroke="#274EA4" stroke-width="4" class="path"></circle>
      </svg>
    </div>
    <div class="loading-text">{{content}}</div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  name: 'loading-dialog',
  props: {
    // 是否显示loading
    visibile: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: '加载中...'
    }
  },
  components: {},
  data() {
    return {count: 0};
  },
  methods: {}

};
</script>

<style lang="scss" rel="stylesheet/scss">
  .loading-content {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    color: #fff;
    text-align: center;
    border-radius: 0.08rem;
    background: rgba(255, 255, 255, 0.9);
    opacity: 0;
    //延迟400ms
    animation-delay: 400ms;
    animation-duration: 10s;
    animation-name: fadeIn;
    animation-fill-mode: forwards;

    .loading-animate {
      position: initial;
      display: flex;
      width: 56px;
      height: 56px;

      .circular {
        width: 56px;
        height: 56px;
      }

      .path {
        stroke: #274ea4;
        stroke-width: 4px;
      }
    }

    .loading-text {
      margin-top: 12px;
      color: #274ea4;
      font-size: 14px;
      line-height: 20px;
    }
  }

  @keyframes cricleLoading {
    0% {
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 1;
    }
  }
</style>
